const UserState = {
    auth: {},
    user: {},
    userProfile: {},
    cluster: {}
};

export default UserState;